import React, { Component } from 'react'
import { CSVLink } from 'react';

class TeamTable extends Component{
    constructor(props) {
        super(props);
        this.csvLink = React.createRef();
    }

    dataTeams = [
      ["no", "nama", "link", "link2"]
    ]
    teamRow(index, name, url, url2) {
        if (this.dataTeams.length <= this.props.teams?.length) {
          let newData = [index+1, name, url, url2];
          this.dataTeams.push(newData);
        }
        return (
          <tr key={index}>
              <th scope="row">{index+1}</th>
              <td>{name}</td>
              <td><a href={url} rel="noopener noreferrer" target="_blank">{url}</a></td>
              <td><a href={url2} rel="noopener noreferrer" target="_blank">{url2}</a></td>
          </tr>)
    }

    render() {
        return (
          <>
            <button class="btn btn-primary m-2" onClick={()=> this.csvLink.current.link.click()}>
            Export data</button>
            <CSVLink data={this.dataTeams} filename="dataS.csv" ref={this.csvLink}/>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">No</th>
                  <th scope="col">Nama</th>
                  <th scope="col">Abstrak</th>
                  <th scope="col">Paper</th>
                </tr>
              </thead>
              <tbody>
                {this.props.teams?.map((t, i) => this.teamRow(i, t.name, t.abstractFileUrl, t.paperFileUrl))}
              </tbody>
            </table>
          </>

        )
    }
}

export default TeamTable;
